/* Shows the bag's dispatch window at checkout (snippets/runit-cart-fulfilment.liquid).
   Shopify checkout lists line properties but not cart attributes, and the store's plan has no
   checkout extensions, so on Checkout each line gets a visible 'Dispatch' property, e.g.
   "Made to order, dispatched in 2 weeks". A mixed bag gives its ready lines the longer
   window too: the order leaves in one parcel. Shopify cannot drop a property in place, so every
   line is rewritten with its current text, which also corrects text left by an earlier visit.
   The click is held while the lines are written, then repeated so the theme's own checkout
   handling runs unchanged. Express buttons and Buy it now skip this and show no Dispatch line. */
(function () {
  var KEY = 'Dispatch';
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var passing = false, pending = false;

  function wanted() {
    var nodes = document.querySelectorAll('[data-runit-dispatch-lines]');
    // The drawer and /cart both render it; the last one in the page is the freshest render.
    try { return JSON.parse(nodes[nodes.length - 1].textContent) || {}; } catch (e) { return {}; }
  }

  // Properties only: a body without `quantity` passes runit-pz-sync.js untouched.
  function stamp(want) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Blank text only clears an old window; a line that never had one is left alone.
        var todo = cart.items.filter(function (it) {
          var had = (it.properties || {})[KEY];
          return it.key in want && (want[it.key] || had) && had !== want[it.key];
        });
        // One at a time: each change gives that line a new key, the others keep theirs.
        return todo.reduce(function (chain, it) {
          return chain.then(function () {
            var props = Object.assign({}, it.properties);
            props[KEY] = want[it.key];
            return fetch('/cart/change.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ id: it.key, properties: props }) });
          });
        }, Promise.resolve());
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="checkout"]');
    if (!btn || passing) return;
    // A second press while the lines are written waits for the first one's click-through.
    if (pending) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    var want = wanted();
    if (!Object.keys(want).length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    pending = true;
    var go = function () {
      if (!pending) return;
      pending = false;
      passing = true; btn.click(); passing = false;
    };
    // Never hold checkout hostage: a slow or failed write goes through without the text.
    setTimeout(go, 5000);
    stamp(want).catch(function () {}).then(go);
  }, true);
})();
